export enum MONITOR_TAB {
  AUDIT = 'audits',
  IMPORT_LOGS = 'import-logs',
  UC_TRANSFORM_OUTPUTS = 'uctransformoutputs',
  INVOICE_IMPORTS = 'invoiceimports',
  WORKDAY_IMPORTS = 'workdayimports',
  WORKDAY_TIME_ALLOCATION_IMPORTS = 'workdaytimeallocationimports',
  UKG_IMPORTS = 'ukgimports'
}
